import { RestAddress } from '../../../hooks/useAddress';
import { BillingAddress } from '../../../hooks/usePaymentMethods';

export const convertBillingAddressToShippingAddress = (
  billingAddress?: BillingAddress | null
): RestAddress => ({
  __typename: 'RestAddress',
  id: '1',
  type: 'addresses',
  attributes: {
    __typename: 'RestAddressAttributes',
    verified: null,
    source: 'moda',
    firstName: '',
    lastName: '',
    addressLine1: billingAddress?.streetAddress || '',
    addressLine2: billingAddress?.extendedAddress || '',
    city: billingAddress?.locality || '',
    state: billingAddress?.region || '',
    postalCode: billingAddress?.postalCode || '',
    phone: '',
    countryCode: billingAddress?.countryCode || ''
  }
});
